import localizationData from "./en.json";
import localized from "model/events/util";

// The first two levels are silent on purpose. A man with a tin who has learned which corner to
// stand on has not crossed anything, and a modal would tell him he had.
//
// The rewards are small and they are all charisma. The path's growth is in `dailyBenefits` over
// in index.js, not here — these used to end on `coins: +50, charisma: +10, luck: +15`, which
// read as a slot machine in a game where health starts at five.
const events = (context, setEvent) =>
  [
    {
      title: "event.charity.mendicant.title",
      description: "event.charity.mendicant.description",
      buttons: [
        {
          title: "Continue",
          message: "event.charity.mendicant.button.message.continue",
          effect: {
            resources: {},
            traits: { charisma: +1 },
          },
        },
      ],
    },
    {
      title: "event.charity.rootDigger.title",
      description: "event.charity.rootDigger.description",
      buttons: [
        {
          title: "Continue",
          message: "event.charity.rootDigger.button.message.continue",
          effect: {
            resources: {},
            traits: { charisma: +1 },
          },
        },
      ],
    },
    {
      title: "event.charity.bottleMan.title",
      description: "event.charity.bottleMan.description",
      buttons: [
        {
          title: "Continue",
          message: "event.charity.bottleMan.button.message.continue",
          effect: {
            resources: {},
            traits: { charisma: +2 },
          },
        },
      ],
    },
    {
      title: "event.charity.healer.title",
      description: "event.charity.healer.description",
      buttons: [
        {
          title: "Continue",
          message: "event.charity.healer.button.message.continue",
          effect: {
            resources: {},
            traits: { charisma: +2 },
          },
        },
      ],
    },
    {
      title: "event.charity.manOfGod.title",
      description: "event.charity.manOfGod.description",
      buttons: [
        {
          title: "Continue",
          message: "event.charity.manOfGod.button.message.continue",
          effect: {
            resources: {},
            traits: { charisma: +3 },
          },
        },
      ],
    },
    {
      title: "event.charity.preacher.title",
      description: "event.charity.preacher.description",
      buttons: [
        {
          title: "Continue",
          message: "event.charity.preacher.button.message.continue",
          effect: {
            resources: {},
            traits: { charisma: +3 },
          },
        },
      ],
    },
    {
      title: "event.charity.shepherd.title",
      description: "event.charity.shepherd.description",
      buttons: [
        {
          title: "Continue",
          message: "event.charity.shepherd.button.message.continue",
          effect: {
            resources: {},
            traits: { charisma: +4 },
          },
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

export default events;
